import React, {useEffect, useReducer} from "react";
import Canvas from "../../layouts/dahboard_canvas";
import DashboardHeader from "../../layouts/dashboard_header";
import SideMenu from "../../layouts/dashboard_menu";
import DashboardFooter from "../../layouts/dashboard_footer";
import {useBaseUrl, useBreadcrumbs, useGetData} from "../../../utils/utils";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {useClinicUserData} from "../../../utils/ClinicUserContext";


const Applications: React.FC = () => {

    const { clinic_id, clinic_name, fname, lname, institution_id, staff_id, token } = useClinicUserData()

    const BetterCallSwal = (issue:any, disp: any, message: any) => {

        Swal.fire({
            title: issue,
            icon: disp,
            text: message
        })

    }

    useEffect(()=>{
        document.title= `My Sent Service request applications`
    })

    const initialState = {
        step: 0,
        subStep: 0,
        cardStep: 0,
        header: "Uzima Healthcare Service Request Management",
        subHeader: "Manage sent service requests and received request applications here",
        selectedService: 0,
        sentRequests: [],
        applications: [],
        selectedApplication: 0,
        selectedRequest: 0

    }

    const reducer = (state: any, action: any) => {

        switch(action.type){

            case 'SET_STEP':
                return {...state, step: action.payload}

            case 'SET_PAGE_HEADING':
                return {...state, header: action.payload}

            case 'SET_SUB_HEADER':
                return {...state, subHeader: action.payload}

            case 'SET_SUB_STEP':
                return {...state, subStep: action.payload}

            case 'SET_CARD_STEP':
                return {...state, cardStep: action.payload}

            case 'SET_SELECTED_SERVICE':
                return {...state, selectedService: action.payload}

            case 'SET_REQUESTS':
                return {...state, sentRequests: action.payload}

            case 'SET_APPLICATIONS':
                return {...state, applications: action.payload}

            case 'SET_SELECTED_REQUEST':
                return {...state, selectedRequest: action.payload}

            default:
                return state
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    const GetSentRequests = async () => {

        const url = `${useBaseUrl()}collaborations/sent-requests/${clinic_id}/9999999999`

        try{

            const resp = await useGetData(url, token)

            if(resp === "undefined" || resp === undefined){

                await BetterCallSwal("Network Error", "info", "We were unable to connect to the internet please check your connection and try again")


            }else{

                dispatch({type:"SET_REQUESTS", payload: resp})

            }

        }catch (e) {

            await BetterCallSwal("Network Error", "warning", "We were unable to connect to the internet please check your connection and try again")

        }
    }

    const GetReceivedApplications = async () => {

        const url = `${useBaseUrl()}/collaborations/service-request-applications`
        
        try{

            const resp = await useGetData(url)

            if(resp === "undefined" || resp === undefined){

                await BetterCallSwal("Network Error", "info", "We were unable to connect to the internet please check your connection and try again")


            }else{

                dispatch({type:"SET_APPLICATIONS", payload: resp})

            }
            
        }catch (e) {

            await BetterCallSwal("Network Error", "warning", "We were unable to connect to the internet please check your connection and try again")

        }

    }

    return(
        <>
            {/*Let's handle services we've applied for and applications to posted service requests here comprehensively*/}
            <DashboardHeader />

            <SideMenu />

            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Service Request Applications</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><a href="javascript: void(0);">Requests</a>
                                </li>
                                <li className="breadcrumb-item active">Tasks List</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>

            <div className={"vertical-overlay"} />

            <div className={"main-content"}>

                <div className={"page-content"}>
                    <div className={"row mt-4 text-center"}>
                        <div className={"col-12"}>
                            <h3>{state.header}</h3>
                        </div>
                    </div>

                    <div className={"row mt-4 text-center"}>
                        <div className={"col"}>
                            <h6>{state.subHeader}</h6>
                        </div>
                    </div>

                    <div className="container-fluid">

                        {state.step === 0 && (
                            <>
                                <div className={"row mt-4"}>

                                    <div className={"col"}>

                                        <div className={"card card-animate"}>

                                            <div className="card-body p-4 text-center" onClick={(e)=>{
                                                dispatch({type: "SET_SUB_HEADER", payload: "Manage sent service requests"})

                                                GetSentRequests()

                                                dispatch({type: "SET_STEP", payload: 1})
                                            }}>
                                                <br />
                                                <br />
                                                <div className="mx-auto avatar-md mb-3">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images/sent.png`}
                                                        alt=""
                                                        className="img-fluid "
                                                    />
                                                </div>
                                                <br />
                                                <h5 className="card-title mb-1">Sent Requests</h5>

                                                <br />

                                            </div>

                                        </div>


                                    </div>

                                    <div className={"col"}>

                                        <div className={"card card-animate"}>

                                            <div className="card-body p-4 text-center" onClick={(e)=>{
                                                dispatch({type: "SET_SUB_HEADER", payload: "Manage sent service requests' applications"})

                                                GetReceivedApplications()

                                                dispatch({type: "SET_STEP", payload: 2})
                                            }}>
                                                <br />
                                                <br />
                                                <div className="mx-auto avatar-md mb-3">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images/received.png`}
                                                        alt=""
                                                        className="img-fluid "
                                                    />
                                                </div>
                                                <br />
                                                <h5 className="card-title mb-1">Request Applications</h5>

                                                <br />

                                            </div>

                                        </div>


                                    </div>

                                    <div className={"col"}>

                                        <div className={"card card-animate"}>

                                            <Link to={"/institution/service-lander"} className="card-body p-4 text-center" >
                                                <br />
                                                <br />
                                                <div className="mx-auto avatar-md mb-3">
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/assets/images/back.png`}
                                                        alt=""
                                                        className="img-fluid "
                                                    />
                                                </div>
                                                <br />
                                                <h5 className="card-title mb-1">Go Back</h5>

                                                <br />

                                            </Link>

                                        </div>


                                    </div>

                                </div>

                            </>
                        )}

                        {state.step === 1 && (
                            <>

                                <div className="row">
                                    <div className="col-xxl-3 col-sm-6">
                                        <div className="card card-animate">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <p className="fw-medium text-muted mb-0">Total Tasks</p>
                                                        <h2 className="mt-4 ff-secondary fw-semibold"><span
                                                            className="counter-value" data-target="234">234</span>k</h2>
                                                        <p className="mb-0 text-muted"><span
                                                            className="badge bg-light text-success mb-0">
                                                    <i className="ri-arrow-up-line align-middle" /> 17.32 %
                                                </span> vs. previous month</p>
                                                    </div>
                                                    <div>
                                                        <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-soft-info text-info rounded-circle fs-4">
                                                    <i className="ri-ticket-2-line" />
                                                </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>


                                    <div className="col-xxl-3 col-sm-6">
                                        <div className="card card-animate">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <p className="fw-medium text-muted mb-0">Pending Tasks</p>
                                                        <h2 className="mt-4 ff-secondary fw-semibold"><span
                                                            className="counter-value" data-target="64.5">64.5</span>k</h2>
                                                        <p className="mb-0 text-muted"><span
                                                            className="badge bg-light text-danger mb-0">
                                                    <i className="ri-arrow-down-line align-middle" /> 0.87 %
                                                </span> vs. previous month</p>
                                                    </div>
                                                    <div>
                                                        <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-soft-warning text-warning rounded-circle fs-4">
                                                    <i className="mdi mdi-timer-sand" />
                                                </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="col-xxl-3 col-sm-6">
                                        <div className="card card-animate">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <p className="fw-medium text-muted mb-0">Completed Tasks</p>
                                                        <h2 className="mt-4 ff-secondary fw-semibold"><span
                                                            className="counter-value" data-target="116.21">116.21</span>K</h2>
                                                        <p className="mb-0 text-muted"><span
                                                            className="badge bg-light text-danger mb-0">
                                                    <i className="ri-arrow-down-line align-middle" /> 2.52 %
                                                </span> vs. previous month</p>
                                                    </div>
                                                    <div>
                                                        <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-soft-success text-success rounded-circle fs-4">
                                                    <i className="ri-checkbox-circle-line" />
                                                </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="col-xxl-3 col-sm-6">
                                        <div className="card card-animate">
                                            <div className="card-body">
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <p className="fw-medium text-muted mb-0">Deleted Tasks</p>
                                                        <h2 className="mt-4 ff-secondary fw-semibold"><span
                                                            className="counter-value" data-target="14.84">14.84</span>%</h2>
                                                        <p className="mb-0 text-muted"><span
                                                            className="badge bg-light text-success mb-0">
                                                    <i className="ri-arrow-up-line align-middle" /> 0.63 %
                                                </span> vs. previous month</p>
                                                    </div>
                                                    <div>
                                                        <div className="avatar-sm flex-shrink-0">
                                                <span
                                                    className="avatar-title bg-soft-danger text-danger rounded-circle fs-4">
                                                    <i className="ri-delete-bin-line" />
                                                </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>


                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card" style={{transform: "None"}} id="tasksList">
                                            <div className="card-header border-0">
                                                <div className="d-flex align-items-center">
                                                    <h5 className="card-title mb-0 flex-grow-1">Sent Service Requests</h5>
                                                    <div className="flex-shrink-0">
                                                        <div className="d-flex flex-wrap gap-2">
                                                            <Link to={"/institution/service-lander"} className="btn btn-danger add-btn" >
                                                                <i className="ri-add-line align-bottom me-1" /> Create Service Request
                                                            </Link>

                                                            <button className={"btn btn-info add-btn"} onClick={(e)=>{
                                                                dispatch({type: "SET_STEP", payload: 0})
                                                            }}>

                                                                Go Back
                                                            </button>
                                                            <button className="btn btn-soft-secondary" id="remove-actions">
                                                                <i className="ri-delete-bin-2-line" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-body border border-dashed border-end-0 border-start-0">

                                            </div>

                                            <div className="card-body">
                                                <div className="table-responsive table-card mb-4">
                                                    <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                                        <thead className="table-light text-muted">
                                                        <tr>
                                                            <th scope="col" style={{width: "40px"}}>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" id="checkAll" value="option" />
                                                                </div>
                                                            </th>
                                                            <th className="sort" data-sort="id">ID</th>
                                                            <th className="sort" data-sort="project_name">Requested Service</th>
                                                            <th className="sort" data-sort="tasks_name">Task</th>
                                                            <th className="sort" data-sort="assignedto">Start Date</th>
                                                            <th className="sort" data-sort="due_date">Due Date</th>
                                                            <th className="sort" data-sort="status">Status</th>
                                                            <th className="sort" data-sort="priority">Priority</th>
                                                            <th className="sort" data-sort="client_name">Action</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody className="list form-check-all">
                                                        <tr>
                                                            {state.sentRequests.service_requests || state.sentRequests.service_requsts === undefined || state.sentRequests.service_requests.Length === 0 && (
                                                                <>
                                                                    <td>You've not created any new service requests. Start by creating one and they will appear here</td>

                                                                </>
                                                            )}

                                                            {state.sentRequests > 0 && (
                                                                <>
                                                                    {state.sentRequests.service_requests.map((req: any)=>(
                                                                        <>
                                                                            <th scope="row">
                                                                                <div className="form-check">
                                                                                    <input className="form-check-input" type="checkbox" name="chk_child" value="option1" />
                                                                                </div>
                                                                            </th>
                                                                            <td className="id">
                                                                                <div className="fw-medium link-primary">#UZM - {req.id}</div>
                                                                            </td>
                                                                            <td className="project_name">
                                                                                <a href="apps-projects-overview.html" className="fw-medium link-primary">Velzon
                                                                                    -
                                                                                    v1.0.0</a></td>
                                                                            <td>
                                                                                <div className="d-flex">
                                                                                    <div className="flex-grow-1 tasks_name">Profile Page
                                                                                        Satructure
                                                                                    </div>
                                                                                    <div className="flex-shrink-0 ms-4">
                                                                                        <ul className="list-inline tasks-list-menu mb-0">
                                                                                            <li className="list-inline-item"><a
                                                                                                href="apps-tasks-details.html"><i
                                                                                                className="ri-eye-fill align-bottom me-2 text-muted"></i></a>
                                                                                            </li>
                                                                                            <li className="list-inline-item"><a
                                                                                                className="edit-item-btn" href="#showModal"
                                                                                                data-bs-toggle="modal"><i
                                                                                                className="ri-pencil-fill align-bottom me-2 text-muted"></i></a>
                                                                                            </li>
                                                                                            <li className="list-inline-item">
                                                                                                <a className="remove-item-btn"
                                                                                                   data-bs-toggle="modal" href="#deleteOrder">
                                                                                                    <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                                                                </a>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className="assignedto">
                                                                                <div className="avatar-group">
                                                                                    <a href="javascript: void(0);" className="avatar-group-item"
                                                                                       data-bs-toggle="tooltip" data-bs-trigger="click"
                                                                                       data-bs-placement="top" aria-label="Frank"
                                                                                       data-bs-original-title="Frank">
                                                                                        <img src="assets/images/users/avatar-3.jpg" alt=""
                                                                                             className="rounded-circle avatar-xxs" />
                                                                                    </a>
                                                                                    <a href="javascript: void(0);" className="avatar-group-item"
                                                                                       data-bs-toggle="tooltip" data-bs-trigger="click"
                                                                                       data-bs-placement="top" aria-label="Anna"
                                                                                       data-bs-original-title="Anna">
                                                                                        <img src="assets/images/users/avatar-1.jpg" alt=""
                                                                                             className="rounded-circle avatar-xxs" />
                                                                                    </a>
                                                                                </div>
                                                                            </td>
                                                                            <td className="due_date">25 Jan, 2022</td>
                                                                            <td className="status"><span
                                                                                className="badge badge-soft-secondary text-uppercase">Reqquesting</span>
                                                                            </td>
                                                                            <td className="priority"><span
                                                                                className="badge bg-danger text-uppercase">High</span></td>
                                                                            <td>
                                                                                <div className={"row mt-1 mb-1"}>
                                                                                    <div className={"col"}>
                                                                                        <button className={"btn btn-danger"} style={{width: "100%"}}>Delete</button>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </>
                                                                    ))}

                                                                </>
                                                            )}
                                                        </tr>
                                                        </tbody>
                                                    </table>

                                                    <div className="noresult" style={{display: "none"}}>
                                                        <div className="text-center">

                                                            <h5 className="mt-2">Sorry! No Result Found</h5>
                                                            <p className="text-muted mb-0">We've searched more than 200k+ tasks
                                                                We did not find any tasks for you search.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-2">
                                                    <div className="pagination-wrap hstack gap-2">

                                                        Pages: {state.sentRequests['total_pages']}

                                                        {state.sentRequests['total_pages'] > "1" && (
                                                            <div className="page-item pagination-prev">
                                                                Previous
                                                            </div>
                                                        )}

                                                        {state.sentRequests['total_pages'] <= "1" || state.sentRequests['total_pages'] === undefined && (

                                                            <div className="page-item pagination-prev disabled">


                                                                Previous
                                                            </div>

                                                        )}

                                                        <ul className="pagination listjs-pagination mb-0">
                                                            <li className="active"><a className="page" href="#" data-i="1"
                                                                                      data-page="8">1</a></li>
                                                        </ul>
                                                        <a className="page-item pagination-next" href="#">
                                                            Next
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <div className="modal fade flip" id="deleteOrder" tabIndex={-1} aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-body p-5 text-center">

                                                <div className="mt-4 text-center">
                                                    <h4>You are about to delete a task ?</h4>
                                                    <p className="text-muted fs-14 mb-4">Deleting your task will remove all of
                                                        your information from our database.</p>
                                                    <div className="hstack gap-2 justify-content-center remove">
                                                        <button
                                                            className="btn btn-link btn-ghost-success fw-medium text-decoration-none"
                                                            id="deleteRecord-close" data-bs-dismiss="modal">
                                                            <i className="ri-close-line me-1 align-middle" /> Close
                                                        </button>
                                                        <button className="btn btn-danger" id="delete-record">Yes, Delete It
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal fade zoomIn" id="showModal" tabIndex={-1}
                                     aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                        <div className="modal-content border-0">
                                            <div className="modal-header p-3 bg-soft-info">
                                                <h5 className="modal-title" id="exampleModalLabel">Create Task</h5>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal"
                                                        aria-label="Close" id="close-modal"></button>
                                            </div>
                                            <form className="tablelist-form" autoComplete="off">
                                                <div className="modal-body">
                                                    <input type="hidden" id="tasksId" />
                                                    <div className="row g-3">
                                                        <div className="col-lg-12">
                                                            <label htmlFor="projectName-field" className="form-label">Project
                                                                Name</label>
                                                            <input type="text" id="projectName-field"
                                                                   className="form-control" placeholder="Project name"
                                                                   required={true} />
                                                        </div>

                                                        <div className="col-lg-12">
                                                            <div>
                                                                <label htmlFor="tasksTitle-field"
                                                                       className="form-label">Title</label>
                                                                <input type="text" id="tasksTitle-field"
                                                                       className="form-control" placeholder="Title"  />
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-12">
                                                            <label htmlFor="clientName-field" className="form-label">Client
                                                                Name</label>
                                                            <input type="text" id="clientName-field"
                                                                   className="form-control" placeholder="Client name" />
                                                        </div>

                                                        <div className="col-lg-12">
                                                            <label className="form-label">Assigned To</label>
                                                            <div data-simplebar="init" style={{height: "95px"}}>
                                                                <div className="simplebar-wrapper" style={{margin: "0px"}}>
                                                                    <div className="simplebar-height-auto-observer-wrapper">
                                                                        <div
                                                                            className="simplebar-height-auto-observer"></div>
                                                                    </div>
                                                                    <div className="simplebar-mask">
                                                                        <div className="simplebar-offset" style={{right: "0px", bottom: "0px"}}>
                                                                            <div className="simplebar-content-wrapper"
                                                                                 tabIndex={0} role="region"
                                                                                 aria-label="scrollable content"
                                                                                 style={{height: "auto", overflow: "hidden"}}>
                                                                                <div className="simplebar-content"
                                                                                     style={{padding: "0px"}}>
                                                                                    <ul className="list-unstyled vstack gap-2 mb-0">
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-2.jpg"
                                                                                                    id="james-forbes" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="james-forbes">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-2.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">James Forbes</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-3.jpg"
                                                                                                    id="john-robles" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="john-robles">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-3.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">John Robles</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-4.jpg"
                                                                                                    id="mary-gant" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="mary-gant">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-4.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Mary Gant</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-1.jpg"
                                                                                                    id="curtis-saenz" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="curtis-saenz">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-1.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Curtis Saenz</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-5.jpg"
                                                                                                    id="virgie-price" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="virgie-price">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-5.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Virgie Price</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-10.jpg"
                                                                                                    id="anthony-mills" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="anthony-mills">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-10.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Anthony Mills</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-6.jpg"
                                                                                                    id="marian-angel" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="marian-angel">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-6.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Marian Angel</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-10.jpg"
                                                                                                    id="johnnie-walton" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="johnnie-walton">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-7.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Johnnie Walton</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-8.jpg"
                                                                                                    id="donna-weston" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="donna-weston">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-8.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Donna Weston</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                        <li>
                                                                                            <div
                                                                                                className="form-check d-flex align-items-center">
                                                                                                <input
                                                                                                    className="form-check-input me-3"
                                                                                                    type="checkbox"
                                                                                                    name="assignedTo[]"
                                                                                                    value="avatar-9.jpg"
                                                                                                    id="diego-norris" />
                                                                                                <label
                                                                                                    className="form-check-label d-flex align-items-center"
                                                                                                    htmlFor="diego-norris">
                                                                    <span className="flex-shrink-0">
                                                                        <img src="assets/images/users/avatar-9.jpg"
                                                                             alt=""
                                                                             className="avatar-xxs rounded-circle" />
                                                                    </span>
                                                                                                    <span
                                                                                                        className="flex-grow-1 ms-2">Diego Norris</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="simplebar-placeholder"
                                                                         style={{width:" 0px", height: "0px"}} />
                                                                </div>
                                                                <div className="simplebar-track simplebar-horizontal"
                                                                     style={{visibility: "hidden"}}>
                                                                    <div className="simplebar-scrollbar"
                                                                         style={{width:" 0px", display: "none"}} />
                                                                </div>
                                                                <div className="simplebar-track simplebar-vertical"
                                                                     style={{visibility: "hidden"}}>
                                                                    <div className="simplebar-scrollbar"
                                                                         style={{height: "0px", display: "none"}} />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <label htmlFor="duedate-field" className="form-label">Due
                                                                Date</label>
                                                            <input type="text" id="duedate-field"
                                                                   className="form-control flatpickr-input"
                                                                   data-provider="flatpickr" placeholder="Due date" readOnly={true} />
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <label htmlFor="ticket-status"
                                                                   className="form-label">Status</label>
                                                            <div className="choices" data-type="select-one" tabIndex={0}
                                                                 role="listbox" aria-haspopup="true" aria-expanded="false">
                                                                <div className="choices__inner"><select
                                                                    className="form-control choices__input" data-choices=""
                                                                    data-choices-search-false="" id="ticket-status" tabIndex={-1} data-choice="active">
                                                                    <option value=""
                                                                            data-custom-properties="[object Object]">Status
                                                                    </option>
                                                                </select>
                                                                    <div className="choices__list choices__list--single">
                                                                        <div
                                                                            className="choices__item choices__placeholder choices__item--selectable"
                                                                            data-item="" data-id="1" data-value=""
                                                                            data-custom-properties="[object Object]"
                                                                            aria-selected="true">Status
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="choices__list choices__list--dropdown"
                                                                     aria-expanded="false">
                                                                    <div className="choices__list" role="listbox">
                                                                        <div id="choices--ticket-status-item-choice-5"
                                                                             className="choices__item choices__item--choice is-selected choices__placeholder choices__item--selectable is-highlighted"
                                                                             role="option" data-choice="" data-id="5"
                                                                             data-value=""
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable=""
                                                                             aria-selected="true">Status
                                                                        </div>
                                                                        <div id="choices--ticket-status-item-choice-1"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="1"
                                                                             data-value="Completed"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">Completed
                                                                        </div>
                                                                        <div id="choices--ticket-status-item-choice-2"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="2"
                                                                             data-value="Inprogress"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">Inprogress
                                                                        </div>
                                                                        <div id="choices--ticket-status-item-choice-3"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="3"
                                                                             data-value="New"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">New
                                                                        </div>
                                                                        <div id="choices--ticket-status-item-choice-4"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="4"
                                                                             data-value="Pending"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">Pending
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <label htmlFor="priority-field"
                                                                   className="form-label">Priority</label>
                                                            <div className="choices" data-type="select-one" tabIndex={0}
                                                                 role="listbox" aria-haspopup="true" aria-expanded="false">
                                                                <div className="choices__inner"><select
                                                                    className="form-control choices__input" data-choices=""
                                                                    data-choices-search-false="" id="priority-field"  tabIndex={-1} data-choice="active">
                                                                    <option value=""
                                                                            data-custom-properties="[object Object]">Priority
                                                                    </option>
                                                                </select>
                                                                    <div className="choices__list choices__list--single">
                                                                        <div
                                                                            className="choices__item choices__placeholder choices__item--selectable"
                                                                            data-item="" data-id="1" data-value=""
                                                                            data-custom-properties="[object Object]"
                                                                            aria-selected="true">Priority
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="choices__list choices__list--dropdown"
                                                                     aria-expanded="false">
                                                                    <div className="choices__list" role="listbox">
                                                                        <div id="choices--priority-field-item-choice-4"
                                                                             className="choices__item choices__item--choice is-selected choices__placeholder choices__item--selectable is-highlighted"
                                                                             role="option" data-choice="" data-id="4"
                                                                             data-value=""
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable=""
                                                                             aria-selected="true">Priority
                                                                        </div>
                                                                        <div id="choices--priority-field-item-choice-1"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="1"
                                                                             data-value="High"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">High
                                                                        </div>
                                                                        <div id="choices--priority-field-item-choice-2"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="2"
                                                                             data-value="Low"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">Low
                                                                        </div>
                                                                        <div id="choices--priority-field-item-choice-3"
                                                                             className="choices__item choices__item--choice choices__item--selectable"
                                                                             role="option" data-choice="" data-id="3"
                                                                             data-value="Medium"
                                                                             data-select-text="Press to select"
                                                                             data-choice-selectable="">Medium
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <div className="hstack gap-2 justify-content-end">
                                                        <button type="button" className="btn btn-light" id="close-modal"
                                                                data-bs-dismiss="modal">Close
                                                        </button>
                                                        <button type="submit" className="btn btn-success" id="add-btn">Add
                                                            Task
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                    </div>


                </div>

                <Canvas />

                <DashboardFooter />
            </div>

        </>
    )
}

export default Applications